<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>发票</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>撮合开票记录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">司机名称</span>
        <el-input v-model.trim="tableOptions.driverName" placeholder="司机姓名关键字搜索"> </el-input>
      </div>
      <div class="toolbar-item" id="auto-1">
        <span class="demonstration">开票日期</span>
        <el-date-picker
          v-model="timeRange"
          :editable="false"
          @change="chioceTime"
          value-format="timestamp"
          type="daterange"
          start-placeholder="请选择开始日期"
          end-placeholder="请选择结束日期"
          :default-time="[' 00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </div>
      <div class="toolbar-item pr-0">
        <el-button type="primary" size="small" @click="handleSearch" id="auto-2">筛选</el-button>
        <el-button size="small" @click="resetSearch" id="auto-5">清除条件</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt">
          开票记录列表：<span class="font-orange">温馨提示，此列表只能查看开票成功后的数据</span>
        </span>
      </div>
      <div class="fr">
        <el-button type="primary" @click="handleExport" size="small" id="auto-7" class="mr-5">导出</el-button>
      </div>
    </div>
    <div class="table-custom-box" id="auto-8">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        ref="tableData"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #submitDate="{ scope }">
          <span>{{ scope.row.submitDate | stamp2TextDate }}</span>
        </template>
        <template #handle="{ scope }">
          <el-button type="text" class="font-size12" v-if="scope.row.invoiceUrl" @click="showBill(scope.row)"
            >发票</el-button
          >
        </template>
      </fe-table>
    </div>

    <export-dialog ref="exportDialog" :exportData="exportData"></export-dialog>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:2
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import dateLimit from '@/api/dateLimit';
import tableMixin from '@/utils/tableMixin';
import ExportDialog from '@/components/ExportDialog';
export default {
  mixins: [tableMixin],
  name: 'MakingInvoice',
  components: {
    ExportDialog
  },
  data() {
    return {
      columns: [
        { label: '订单号', prop: 'matchmakingOrderNo', 'min-width': 200 },
        { label: '开票日期', prop: 'submitDate', 'min-width': 100 },
        { label: '发票类型', prop: 'invoiceTypeName', 'min-width': 100 },
        { label: '发票号码', prop: 'invoiceNo', 'min-width': 100 },
        { label: '发票金额（元）', prop: 'actualPrice', 'min-width': 100 },
        { label: '司机名称', prop: 'driverName', 'min-width': 100 },
        { label: '开票方名称', prop: 'taxCompanyName', 'min-width': 200 },
        { label: '操作', prop: 'handle', 'min-width': 90 }
      ],
      axiosConfig: { url: api.queryMatchmakingInvoiceList }, // 列表接口
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      },
      timeRange: [],
      tableOptions: {
        driverName: '',
        queryBeginDate: null,
        queryEndDate: null
      },
      exportData: {},
      time: 8.64e7
    };
  },
  created() {
    this.handleSearch();
  },
  methods: {
    chioceTime(val) {
      if (val) {
        this.tableOptions.queryBeginDate = new Date(val[0]).getTime();
        this.tableOptions.queryEndDate = new Date(val[1]).getTime();
      } else {
        this.tableOptions.queryBeginDate = null;
        this.tableOptions.queryEndDate = null;
      }
    },
    resetSearch() {
      this.tableOptions.driverName = '';
      this.tableOptions.queryBeginDate = null;
      this.tableOptions.queryEndDate = null;
      this.timeRange = [];
    },
    showBill(item) {
      this.$store.dispatch('showViewer', { data: [{ url: item.invoiceUrl }] });
    },
    handleExport() {
      if (this.tableData.length == 0) {
        this.$message.warning('未查询到数据，请重新筛选');
        return;
      }
      this.exportData = {
        exportUrl: api.exportMatchmakingInvoiceList,
        opts: this.sendOptions,
        sDate: this.sendOptions.queryBeginDate,
        eDate: this.sendOptions.queryEndDate
      };
      this.$refs.exportDialog.showExportBox();
    }
  }
};
</script>
